import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "漫画库", to: "/list" },
  { label: "高甜榜", to: "/list?tab=hot" },
  { label: "少女馆", to: "/list?cat=少女" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(keyword.trim() ? `/list?q=${encodeURIComponent(keyword.trim())}` : "/list");
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    if (to.startsWith("/list")) return location.pathname === "/list";
    return false;
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 shadow-[0_1px_0_oklch(var(--primary-200))] backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="布丁漫画网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-cup-line" aria-hidden="true"></i>
          </span>
          <span className="whitespace-nowrap font-heading text-xl text-foreground-900">
            布丁<span className="text-primary-500">漫画网</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-full px-4 py-2 text-sm transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 font-medium text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <form onSubmit={submitSearch} className="relative hidden sm:block" role="search">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜漫画 / 标签 / 作者"
              className="h-9 w-44 rounded-full border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 lg:w-56"
              aria-label="搜索漫画"
            />
          </form>
          <Link
            to="/list"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            开始阅读
          </Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 md:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <form onSubmit={submitSearch} className="relative mt-2" role="search">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜漫画 / 标签 / 作者"
              className="h-10 w-full rounded-full border border-background-300 bg-background-50 pl-9 pr-3 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-400"
              aria-label="搜索漫画"
            />
          </form>
          <nav className="mt-2 flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/list"
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50"
            >
              开始阅读
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}